"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.insertSiteRevision = insertSiteRevision;
const SITE_REVISION_PARAM = 'siteRevision';
function insertSiteRevision(currentUrl, urlOrPath) {
    const siteRevision = currentUrl.searchParams.get(SITE_REVISION_PARAM);
    if (!siteRevision) {
        return urlOrPath.toString();
    }
    const urlObject = new URL(urlOrPath, currentUrl);
    urlObject.searchParams.set(SITE_REVISION_PARAM, siteRevision);
    return urlObject.toString();
}
